import type { ComponentType } from 'react';
import type { ToastOptions } from 'react-toastify';

import { CheckCircleIcon } from '#icons/CheckCircleIcon';
import { InfoCircleIcon } from '#icons/InfoCircleIcon';
import type { IconProps } from '#icons/types';
import { XCircleIcon } from '#icons/XCircleIcon';

import type { ToastVariant } from './types';

export const variantToBackgroundColorMap: Record<ToastVariant, string> = {
  success: 'ods-bg-success-m2',
  error: 'ods-bg-error-m1',
  info: 'ods-bg-info-m3',
  warning: 'ods-bg-warning-m2',
};

export const variantToColorMap: Record<ToastVariant, string> = {
  success: 'ods-text-success-p3',
  error: 'ods-text-error-p2',
  info: 'ods-text-info-p1',
  warning: 'ods-text-warning-p2',
};

export const variantToIconMapping: Record<string, ComponentType<IconProps>> = {
  success: CheckCircleIcon,
  error: XCircleIcon,
  warning: InfoCircleIcon,
  info: InfoCircleIcon,
};

export const defaultToastOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 2000,
  closeButton: false,
  hideProgressBar: true,
};
